import BasicRouterView from "../../../components/BasicRouterView.vue";

const userRoutes = {
  path: "user",
  redirect: { name: "usuario-lista" },
  meta: {
    label: "Usuarios",
    icon: "person",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "usuario/usuario-lista",
      name: "usuario-lista",
      meta: {
        label: "Lista de Usuarios",
        icon: "settings",
        show: true,
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/ListaUsuario.vue"),
    },
    {
      path: "usuario/usuario-criar",
      name: "usuario-criar",
      meta: {
        label: "Criar Usuario",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/CriarUsuario.vue"),
    },
    {
      path: "usuario/usuario-criar-planilha",
      name: "usuario-criar-planilha",
      meta: {
        label: "Criar Usuario por Planilha",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/CriarUsuarioPlanilha.vue"
        ),
    },
    {
      path: "usuario/usuario-editar/:id",
      name: "usuario-editar",
      meta: {
        label: "Criar Usuario por Planilha",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/EditarUsuario.vue"),
    },
    {
      path: "usuario/usuario-pin",
      name: "usuario-pins",
      meta: {
        label: "Listagem de Pins",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/ListaPins.vue"),
    },
    {
      path: "usuario/usuario-libera-prazo",
      name: "usuario-libera-prazo",
      meta: {
        label: "Liberação Prazo Minimo",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/LiberaPrazo.vue"),
    },
    {
      path: "usuario/usuario-libera-prazo-liderados",
      name: "usuario-libera-prazo-liderados",
      meta: {
        label: "Liberação Prazo Mínimo - Meus Liderados",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/LiberaPrazoLiderados.vue"
        ),
    },
    {
      path: "usuario/usuario-hierarquia/:id",
      name: "usuario-hierarquia",
      meta: {
        label: "Definir Hierarquia",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/Hierarquia.vue"),
    },

    {
      path: "usuario/usuario-biometria-list/:id",
      name: "usuario-biometria-list",
      meta: {
        label: "Visualização Biometrias",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/BiometriaList"),
    },
    {
      path: "usuario/usuario-epi/:id",
      name: "usuario-epi",
      meta: {
        label: "Liberação Prazo Minimo",
        icon: "settings",

        show: false,
      },
      component: () => import(/* webpackChunkName: "pdt" */ "./views/EPI.vue"),
    },
    {
      path: "usuario/permissao-executor",
      name: "usuario-permissao-executor",
      meta: {
        label: "Criar Permissão de Executor",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/PermissaoExecutor.vue"),
    },
    {
      path: "usuario/termo/:id",
      name: "usuario-termo",
      meta: {
        label: "Termo de Aceite",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/TermoAceite.vue"),
    },
  ],
};

export default userRoutes;
